import { app } from '../../../bootstrap/core';
import { userSummaryComponent } from './userSummary.component';
import './adviserForm/adviserForm';
import './section/userSummarySection';
import userSummaryIncomingTemplate from './partials/userSummary.incoming.tpl.html';
import userSummaryOutgoingTemplate from './partials/userSummary.outgoing.tpl.html';
import { UserFormFields } from './userSummary.constants';
import { UserSummaryServiceProvider } from './userSummary.service.provider';

app.provider('userSummaryServiceProvider', UserSummaryServiceProvider);
app.component('userSummary', userSummaryComponent);
app.value('userSummaryIncomingTemplate', userSummaryIncomingTemplate);
app.value('userSummaryOutgoingTemplate', userSummaryOutgoingTemplate);
app.constant('UserFormFields', UserFormFields);
